import translations from "../assets/locales/fa.json";

// interface OptionsBaseType {
//   returnObjects?: boolean;
// }
//
// interface StringMap {
//   [key: string]: string | boolean;
// }
// type OptionsType = OptionsBaseType & StringMap;
interface OptionsType {
  returnObjects?: boolean;
  [key: string]: string | boolean | undefined;
}
type RecursiveArray = Array<RecursiveArray | string>;

function getTranslationResult(tKey: string): string | RecursiveArray {
  const path = tKey.split(".");
  let res: any = translations;
  for (let i = 0; i < path.length; i += 1) {
    res = res[path[i]];
  }
  return res as unknown as string;
}

function replaceVars(trans: string, vars: Record<string, unknown>): string {
  let result = trans?.replace(/{{ /g, "{{").replace(/ }}/g, "}}");
  if (vars) {
    Object.entries(vars)?.forEach(([key, value]) => {
      if (typeof value === "string") result = result?.replace(RegExp(`{{${key}}}`, "g"), value);
    });
  }
  return result;
}

function loopArr(transArr: string | RecursiveArray, vars: Record<string, unknown>): string | RecursiveArray {
  if (typeof transArr === "string") return replaceVars(transArr, vars);
  return transArr?.map((trans) => loopArr(trans, vars));
}

// TODO: this is a mock of real translation function. When i18n is needed, it should be replace this.
export function useAppTranslation() {
  return {
    t: (tKey: string, allOptions: OptionsType = {}): any => {
      const { returnObjects = false, ...options } = allOptions;
      if (returnObjects) {
        const arrResult = loopArr(getTranslationResult(tKey), options);
        return arrResult;
      }
      const result = replaceVars(getTranslationResult(tKey)?.toString(), options);
      return result;
    },
  };
}
